// Top marketing nav — shown on landing + all public marketing sub-pages.
// D2.4: adds Pricing / Features / About / For schools links + persistent "Get started free" CTA.
import { Link, NavLink } from "react-router-dom";
import { BookOpen, Menu, X } from "lucide-react";
import { useState } from "react";

const NAV = [
  { to: "/pricing", label: "Pricing" },
  { to: "/features", label: "Features" },
  { to: "/for-schools", label: "For schools" },
  { to: "/customers", label: "Customers" },
  { to: "/about", label: "About" },
];

export const MarketingNav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/85 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="marketing-nav-logo">
          <span className="grid place-items-center h-8 w-8 rounded-xl bg-primary text-primary-foreground">
            <BookOpen className="h-4 w-4" />
          </span>
          <span className="font-serif text-xl font-bold">Lectura<span className="text-accent">.</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-medium transition ${isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-2">
          <Link to="/login" data-testid="nav-signin" className="px-3 py-1.5 text-sm font-semibold text-foreground/80 hover:text-foreground">
            Sign in
          </Link>
          <Link
            to="/register"
            data-testid="nav-get-started"
            className="rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-bold hover:opacity-90 transition"
          >
            Get started free
          </Link>
        </div>
        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          className="md:hidden grid place-items-center h-9 w-9 rounded-lg border border-border"
          aria-label="Menu"
        >
          {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border/60 bg-background">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="py-2 text-sm font-medium text-foreground/90"
              >
                {n.label}
              </Link>
            ))}
            <div className="flex gap-2 pt-2">
              <Link to="/login" onClick={() => setOpen(false)} className="flex-1 text-center rounded-full border border-border px-4 py-2 text-sm font-semibold">
                Sign in
              </Link>
              <Link to="/register" onClick={() => setOpen(false)} className="flex-1 text-center rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-bold">
                Get started free
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default MarketingNav;
